import { Organisation } from '../../api/search/searchOrganisations/searchOrganisations.types'
import { VerifiedOrganisationSearchResult } from '../../api/search/searchOrganisations/searchVerifiedOrganisations.types'

export const mapVerifiedOrgToRegularOrg = (
  verifiedOrg?: VerifiedOrganisationSearchResult
): Organisation | undefined => {
  if (!verifiedOrg) return undefined

  const addressParts = [verifiedOrg.address?.line1, verifiedOrg.address?.city].filter((part): part is string => !!part)

  return {
    ...verifiedOrg,
    id: verifiedOrg.organisationId,
    registryId: verifiedOrg.organisationIdInRegistry,
    address: addressParts.length > 0 ? addressParts.join(', ') : null,
    addressLine1: verifiedOrg.address?.line1 ?? null,
    addressLine2: verifiedOrg.address?.line2 ?? null,
    postalCode: verifiedOrg.address?.postalCode ?? null
  }
}
